import CustomerDialog from './CustomerDialog';

export default CustomerDialog;
